import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../allcss/blog5.css';
import blogImage from '../Asets/Blog.jpg';
import blog1 from '../Asets/blog22.jpg';
import Header from '../components/header';
import Footer from '../components/footer';

const Blog = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div className="blog-section">
        {/* Hero Section */}
        <div className="blog-hero" style={{ backgroundImage: `url(${blogImage})` }}>
          <div className="blog-overlay">
            <h1 className="blog-title">Our Blog</h1>
            <p className="breadcrumb">
              <span
                style={{ cursor: 'pointer', color: '#fff' }}
                onClick={() => navigate('/')}
              >
                Home
              </span>
              <span> / Our Blog</span>
            </p>
          </div>
        </div>

        {/* Blog Detail */}
        <div className="blog-container">
          <h2 className="section-title">Why Red School House is the Best School in Vadodara</h2><br />
          <div className="published-badge">Published on: 07 August 2025</div><br />

          <img src={blog1} alt="Best School in Vadodara" className="blog-detail-img" />

          <div className="blog-detail-content">
            <p><strong>Choosing the Right School in Vadodara: Why Redschool House Stands Out</strong></p>
            <p>
              Choosing the right school for your child is one of the most significant decisions a parent makes. It's not just about finding a place for academic learning; it's about discovering an environment that nurtures curiosity, builds character, and fosters all-round growth. For parents seeking the best school in Vadodara, the search often leads to one name: Redschool House.
            </p>
            <p>This blog post will take you on a detailed journey through the philosophy, facilities, and unique offerings of Redschool House, showcasing why it stands out as a top choice for your child's future.</p>

            <p><strong>Our Vision: More Than Just Marks</strong></p>
            <p>
              At Redschool House, our guiding principle is to cultivate a love for learning. We believe that true education transcends the report card. Our vision is to empower students to become critical thinkers, compassionate citizens, and confident leaders of tomorrow. We are committed to providing a holistic education in Vadodara that balances academic rigor with personal development.
            </p>

            <p><strong>Beyond the Classroom: Shaping Well-Rounded Individuals</strong></p>
            <p>We firmly believe that some of the most important life lessons are learned outside the classroom. Our extensive range of extracurricular activities ensures that every child can explore their passions and develop new skills.</p>

            <ul>
              <li><strong>Sports and Physical Education:</strong> From basketball and cricket to athletics and yoga, our sports program is designed to promote physical fitness, teamwork, and sportsmanship. Our campus includes modern sports facilities to support these activities.</li><br />
              <li><strong>The Arts:</strong> Creativity is intelligence having fun! We offer dedicated programs in music, dance, drama, and visual arts, allowing students to express themselves and build confidence through events like annual day functions and art exhibitions.</li><br />
              <li><strong>Leadership and Community Service:</strong> We nurture a sense of social responsibility through various clubs and initiatives, such as the Eco Club, Interact Club, and community outreach programs.</li><br />
            </ul>

            <p><strong>State-of-the-Art Facilities for 21st-Century Learning</strong></p>
            <ul>
              <li><strong>Smart Classrooms:</strong> Digitally enabled classrooms to make learning interactive and visually engaging.</li><br />
              <li><strong>Secure Campus:</strong> The safety of our students is paramount. Our campus is monitored by CCTV and staffed by trained security personnel.</li><br />
              <li><strong>Hygienic Cafeteria:</strong> We provide nutritious and wholesome meals prepared in a clean, modern kitchen.</li><br />
            </ul>

            <p><strong>Hear From Our Community: Testimonials</strong></p>
            <p><em>"Switching to Redschool House was the best decision for my daughter. The teachers are incredibly supportive, and the focus on both academics and personal growth is amazing. She has become so much more confident. It truly feels like one of the top-rated schools in Vadodara."</em> – A Parent</p>
            <p><em>"I love the projects we do in science class and the sports activities after school. The teachers make learning fun, and I have made so many friends here."</em> – A Student</p>

            <p><strong>Admissions Open for 2025–2026: Join the Redschool House Family</strong></p>
            <p>
              Are you ready to give your child an education that prepares them for life? The school admissions process in Vadodara can be competitive, and we invite you to take the first step towards securing a place at Redschool House.
            </p>
            <p>
              We are currently accepting applications for the academic year 2025–2026.
            </p>
            <ul>
              <li><strong>Visit our Website</strong></li>
              <li><strong>Schedule a Campus Tour:</strong> We would love to show you our school in person.</li>
              <li><strong>Contact Our Admissions Office:</strong> Call us at +917778851070 for any queries.</li>
            </ul>
            <p><strong>Don't miss the opportunity to become part of a vibrant and forward-thinking educational community. Choose Redschool House—where excellence is a way of life.</strong></p>

            {/* Go Back Button */}
            <div className="back-to-blogs-btn-wrapper">
              <button
                className="back-to-blogs-btn"
                onClick={() => navigate('/blog')}
              >
                Go Back To Blogs
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Blog;
